import React,{useState,useEffect} from 'react';
import Modal from "react-bootstrap/Modal";
import Wrp from '../../../../hoc/Wrp/Wrp';
import * as ShipConstants from '../../../../Global/Constants';
import Icons from '../../../../Components/Icons/Icons';
import { setArrayIndexes, isSet,prepareApiName } from '../../../../Utils/CommonFunctions';
import WindowMapFields from '../../../StepsFlowContainer/StepsCustomize/StepsSidebar/Variables/WindowMapFields';
import $ from 'jquery';
import http from '../../../../services/http';
import ArrayElement from '../../../../Components/ArrayElement';
import { withRouter } from 'react-router';

const CreateVariable = (props) => {
    const [windowFields,setWindowFields] = useState({});
	const [payload, setPayload] = useState({
        variable_name : '',
        variable_type : 'LOCAL',
        is_constant : false,
        constant_value : null,
        fieldtype_id : '',
        ratesheet_id : '',
        fieldtype_name : '',
        max_value : 1,
        decimal_places : 0,
        fields: [],
        function_type:'EXCEL',
        is_response:false,
        is_request:true,
        field_expression:'',
    });

    const [errorDefaultFields, setErrorDefaultFields] = useState([
	    {
	      "name": "type",
	      "field_type_id": "",
	      "fieldtype_name": "",
	      "indexes": ",0",
	      "max_value": 0,
	      "decimal_places": 0,
	      "fields": [],
	      "field_expression": "",
	      "displayPosition": 1
	    },
	    {
	      "name": "message",
	      "field_type_id": "",
	      "fieldtype_name": "",
	      "indexes": ",1",
	      "max_value": 0,
	      "decimal_places": 0,
	      "fields": [],
	      "field_expression": "",
	      "displayPosition": 2
	    }
    ])

    const[arrayElementData , setArrayElementData] = useState({
        isArrayElementModalOpen:false,
        arrayElement:null
    })

    const toogleArrayElementModel = (arrayData) => {
        setArrayElementData({isArrayElementModalOpen:!arrayElementData.isArrayElementModalOpen,arrayElement:arrayData});
    }

    useEffect(()=>{
        if(isSet(props.editData.id,null)!==null){
            setPayload(isSet(props.editData,{}));
        }
    },[props.editData])

    const clearFormValues = (closeModel=false)=>{
        setPayload({
            variable_name : '',
                    variable_type : 'LOCAL',
                    is_constant : false,
                    constant_value : null,
                    fieldtype_id : '',
                    ratesheet_id : '',
                    fieldtype_name : '',
                    max_value : 1,
                    decimal_places : 0,
                    fields: [{
                        "name": "",
                        "field_type_id": "",
                        "fieldtype_name": "",
                        "indexes":"",
                        "max_value":0,
                        "decimal_places":0,
                        "fields": [],
                        "field_expression":""
                    }],
                    function_type:'EXCEL',
                    is_response:false,
                    is_request:true,
                    field_expression:'' 
        })
        if(closeModel===true){
            props.toggleVariableModel();
        }
    }

    const variableChangeHandler = (e) => {
        const { name,value } = e.target;
        const list = {...payload}
        let regExp = /[a-zA-Z]/g;

        if(name === 'fieldtype_id') {
            const fieldName = e.target.selectedOptions[0].text;
            // console.log(fieldName);
            list['constant_value'] = '';
            list['fieldtype_name'] = fieldName;
        }

        if(name === 'constant_value' && list['fieldtype_name'] === 'Decimal'){
            if(!regExp.test(value)) {
                if(value.indexOf('.') !== -1) {
                    if ((value.substring(value.indexOf('.')).length - 1) <= payload.decimal_places){
                        list[name] = value;
                    }
                }else {
                    list[name] = value;
                }
            }
        }else if(name === 'max_value' || name === 'decimal_places') { 
            list['constant_value'] = '';
            list[name] = value;   
        }else {
            list[name] = value;    
        }
        
        setPayload(list);
    }

    const checkThisIsErrorFieldType = () => {  
        const {variablesAndFields} = props;      
        const list = {...payload};
        if(isSet(list.id,null)===null){
            if(list.fieldtype_name==='Messages'){
                let field_type_id = '';
                let fieldtype_name = 'TextInput';
                list['fields'] = errorDefaultFields;
                if(isSet(variablesAndFields.field_type,[]).length>0){                    
                    const fieldTypeIndexByName = variablesAndFields.field_type.findIndex(i=>i.type_name===fieldtype_name);                                        
                    if(fieldTypeIndexByName!==-1){
                        field_type_id = variablesAndFields.field_type[fieldTypeIndexByName].id;
                    }
                    list['fields'][0]['field_type_id'] = field_type_id;
                    list['fields'][0]['fieldtype_name'] = fieldtype_name;
                    list['fields'][1]['field_type_id'] = field_type_id;
                    list['fields'][1]['fieldtype_name'] = fieldtype_name;  
                }
                setPayload(list);
                toogleArrayElementModel();
            }else{
                toogleArrayElementModel();    
            }
        }else{
            toogleArrayElementModel();
        }
    }

    const arrayChangeHandler = (e,ind) => {
        const {name,value} = e.target;
        const data = {...payload};
        let indArr = ind.split(",");
        let cleanArr = indArr.filter((a) => a);
        let str = 'data.';
        cleanArr.map((item,iInd) => {
            str += cleanArr.length === iInd+1 ? "fields["+item+"]" : "fields["+item+"].";
        })
        let dat = eval(str);
        if(name === "field_type_id") {
            const fieldName = e.target.selectedOptions[0].text;
            dat["fieldtype_name"]=fieldName;
            dat["field_expression"]="";
        }
        dat[name]=value;
        setPayload(data);
    }

    const addArrayRow = (ind='') => {
        // console.log(ind);
        const data = {...payload};
        const addArrayElementRow =  {
                "name": "",
                "field_type_id": "",
                "fieldtype_name": "",
                "indexes":"",
                "max_value":0,
                "decimal_places":0,
                "fields": [],
                "field_expression":""
            }

        if(ind !== "") {
            let indArr = ind.split(",");
            let cleanArr = indArr.filter((a) => a);
            let str = 'data.';
            cleanArr.map((item,iInd) => {
                str += cleanArr.length === iInd+1 ? "fields["+item+"]" : "fields["+item+"].";
            })
            let dat = eval(str);
            dat.fields.push(addArrayElementRow); 
            setArrayIndexes(data);  
            setPayload(data);
        }else {
            // console.log(data);
            data.fields.push(addArrayElementRow);   
            setArrayIndexes(data);
            setPayload(data);
        }
    }

    const deleteArrayRow = (ind,id) => {
        const data = {...payload};
        let indArr = ind.split(",");
        let cleanArr = indArr.filter((a) => a);
        // console.log(ind,id);
        if(id && id!== "") {
            props.Loader(true);
            http.DELETE("variable/field/"+id+"/delete")
            .then(response => {
                props.Loader(false);
                const responseData = response.data;
                if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
                    if(cleanArr.length === 1) {
                        data.fields.splice(cleanArr[0], 1); 
                    }else {
                        let lastElement = cleanArr[cleanArr.length - 1];
                        // cleanArr = cleanArr.pop();
                        let newArr = [];
                        newArr.push.apply(newArr, cleanArr);
                        newArr.pop();
                        // console.log(cleanArr,lastElement,newArr)
                        let str = 'data.';
                        newArr.map((item,iInd) => {
                            str += newArr.length === iInd+1 ? "fields["+item+"]" : "fields["+item+"].";
                        })
                        let dat = eval(str);
                        dat.fields.splice(lastElement, 1); 
                    }
                    setArrayIndexes(data);  
                    setPayload(data);
                }else {
                  props.failMessage(responseData.message);
                }
            })

        }else {
            if(cleanArr.length === 1) {
                data.fields.splice(cleanArr[0], 1); 
            }else {
                let lastElement = cleanArr[cleanArr.length - 1];
                // cleanArr = cleanArr.pop();
                let newArr = [];
                newArr.push.apply(newArr, cleanArr);
                newArr.pop();
                // console.log(cleanArr,lastElement,newArr)
                let str = 'data.';
                newArr.map((item,iInd) => {
                    str += newArr.length === iInd+1 ? "fields["+item+"]" : "fields["+item+"].";
                })
                let dat = eval(str);
                dat.fields.splice(lastElement, 1); 
            }
            setArrayIndexes(data);  
            setPayload(data);
        }
        
        
    }

    

    const collapseAllHandler = () => {
        $('.collapseRole').hide(300);
        $('ul li').children('span')
                        .removeClass('minus');
        $('ul li').children('span')
                        .addClass('plus');
    }

    const expandAllHandler = () => {
        $('.collapseRole').show(300);
        $('ul li').children('span')
                        .removeClass('plus');
        $('ul li').children('span')
                        .addClass('minus');
    }

    const generateWindowFields = (windowId) => {
        if(isSet(windowFields[windowId],null)===null){
          http.GET('field-groups/window/'+windowId+'/lookup-layouts')
          .then(windowResponse => {
            //   this.props.Loader(false);
              const responseData = windowResponse.data;
              if(responseData.code === 200) {
                setWindowFields({
                    ...windowFields,
                    [windowId]:responseData.data
                });
              }
          }, (error) => {
              console.log(error);
            //   this.props.Loader(false);
          })
        }    
      }

    const saveHandler = () => {
        const params = props.match.params;
        props.Loader();
        const body = {
            id:payload.id,
            variable_name : payload.variable_name,
            variable_type : payload.variable_type,
            is_constant : payload.is_constant,
            constant_value : payload.constant_value,
            fieldtype_id : payload.fieldtype_id,
            fieldtype_name: payload.fieldtype_name,
            reference_id : params.excelTemplateId,
            max_value : payload.fieldtype_name === 'Decimal' ? payload.max_value : 0,
            decimal_places : payload.fieldtype_name === 'Decimal' ? payload.decimal_places : 0,
            fields: prepareApiName(payload.fields),
            function_type:'PDF',
            is_response:payload.is_response,
            is_request:payload.is_request,
            field_expression:payload.field_expression,
        }
        // console.log('body payload===',body); return false;
        http.POST("variable/save",body)
          .then(response => {
            props.Loader();
            // console.log(response);
            const responseData = response.data;
            if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
              // props.history.push("/workflow");
              props.succMessage(responseData.message);
              clearFormValues();
              props.toggleVariableModel();
              props.fetchVariableList();
              props.recordsChangeHandler()
            }else {
              props.failMessage(responseData.message);
            }
          })
          .catch(err => {
            props.Loader();
            props.failMessage("Error occured");
            console.log(err);
          })
    }

	const {isVariableModalOpen,isEdit,variablesAndFields,toggleVariableModel} = props;
	const max_value_cnt = 16;
	let decimal_cnt = 0;
    if(parseInt(payload.max_value) > 10) {
        decimal_cnt = 10
    }else {
        decimal_cnt = parseInt(payload.max_value);
    }
	return (
		<Modal size="lg" show={isVariableModalOpen}>
			<Modal.Header>
                <h6 className="modal-title secondary_color mb-0"> 
                	{isSet(payload.id,null)===null?'Create':'Update'} 
                </h6>
            </Modal.Header>
            <Modal.Body>
            	<div className="row">
                    <div className="col-12">
                        <div className="form-group">
                            <label> Name</label>
                            <input type="text" className="form-control" 
                            name="variable_name" value={payload.variable_name} 
                            onChange={variableChangeHandler} disabled={isEdit}/>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="form-group">
                            <label> Field Type </label>
                            <select className="form-control custom-arrow" name="fieldtype_id" value={payload.fieldtype_id} onChange={variableChangeHandler} disabled={isEdit}>
                                <option value=""></option>
                            {
                                variablesAndFields ? 
                                    variablesAndFields.field_type ?
                                        variablesAndFields.field_type.map((arr,i) => {
                                            return <option key={i} value={arr.id}>{arr.type_name}</option>
                                        })
                                    : null
                                : null
                            }
                            </select>
                        </div>
                    </div>
                    { payload.fieldtype_name === 'Decimal' ? 
                        <Wrp>
                            <div className="col-12">
                                <div className="form-group">
                                    <label> Max Digits </label>
                                    <select className="form-control custom-arrow" name="max_value" value={payload.max_value} onChange={variableChangeHandler}>
                                    { [...Array(max_value_cnt)].map((elementInArray, index) => ( 
                                                <option key={index} value={index + 1}>{index + 1}</option>
                                            ) 
                                    ) }
                                    </select>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="form-group">
                                    <label> Decimal </label>
                                    <select className="form-control custom-arrow" name="decimal_places" value={payload.decimal_places} onChange={variableChangeHandler}>
                                        {[...Array(decimal_cnt)].map((elementInArray, index) => ( 
                                                    <option key={index} value={index}>{index}</option>
                                                ) 
                                        )}
                                    </select>
                                </div>
                            </div>
                        </Wrp>
                    : (ShipConstants.VARIABLE_CONSTANT_TYPE.indexOf(payload.fieldtype_name) !== -1 )? 
                        <div className="col-12 mb-2">
                            <a className="cursor-pointer" onClick={checkThisIsErrorFieldType}>
                                <span className="svgIcon"> <Icons iconType="AddPlusTwo" /> </span> Add {payload.fieldtype_name} Element
                            </a>
                        </div>
                       
                    : null }
                    {payload.is_constant === true && payload.fieldtype_name !== 'Array' ?
                        <div className="col-12">
                            <div className="form-group">
                                <label> Constant Value </label>
                                {/*<FormInputFields 
                                                                    type={formInputFieldsKeyRef(payload.fieldtype_name)}
                                                                    attributes={{
                                                                        ...constantAttributes,
                                                                        // id:'constantValue',
                                                                        id:'constantValue',
                                                                        // getDateFormat:getDateFormat('DateTime')
                                                                    }}
                                                                    changeHandler={(val)=>onChangeValueHandler('constant_value',val)}
                                                                    value={payload.constant_value}
                                                                />*/}
                                
                            </div>
                        </div>
                    : null }
                    <div className="col-12">
                        <div className="form-group">
                            <label> Variable Type </label>
                            <select className="form-control custom-arrow" name="variable_type" value={payload.variable_type} onChange={variableChangeHandler} disabled={isEdit}>
                            <option value="LOCAL">LOCAL</option>
                            <option value="GLOBAL">GLOBAL</option>
                            </select>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
               <div className="ml-md-auto py-2 py-md-0">
                    <a onClick={()=>clearFormValues(true)} className="btn btn-border border-default mr-2" data-dismiss="modal"> Cancel </a> 
                    <a onClick={saveHandler} className="btn primary_bg" data-dismiss="modal"> Save </a> 
                </div>
            </Modal.Footer>

            <ArrayElement
              toogleArrayElementModel={toogleArrayElementModel}
              arrayElement={payload}
              changeHandler={arrayChangeHandler}
              addRow={addArrayRow}
              deleteRow={deleteArrayRow}
              collapseAllHandler= {collapseAllHandler} 
              expandAllHandler={expandAllHandler} 
              isArrayElementModalOpen={arrayElementData.isArrayElementModalOpen}
              variablesAndFields={variablesAndFields}
              currentTab={(isSet(payload.window_id,null)!==null)?'VARIABLE':'VARIABLE'}
              >
              {(payload.fieldtype_name==='Object' || payload.fieldtype_name=='Array')?
                  <WindowMapFields 
                      generateWindowFields={generateWindowFields}
                      variablesAndFields={variablesAndFields.field_type}
                      isAssignFieldOnly={'ALL'} 
                      windowsList={props.windowsList.map((item)=>{
                        return{
                            value:item.window_name,
                            id:item.id,
                            label:item.window_name
                        }
                      })}
                      windowFields={windowFields}
                      updateWindowId={(winId)=>setPayload({...payload,'window_id':winId})}
                      updateFields={(fields)=>setPayload({...payload,'fields':fields})}
                      payload={payload}/>
              :<></>}
              
            </ArrayElement>
		</Modal>
	)
}

export default withRouter(CreateVariable);